/* eslint-disable import/extensions */

// Services Img Imports
import Web from "../assets/images/Services/Production.jpg";
import Mobile from "../assets/images/Services/Casting.jpg";
import UIUX from "../assets/images/Services/television-advertising.png";

// Portfolio Img Imports
import Recruiting from "../assets/images/Portfolio/Vicky-Vidya-Ka-Wo.webp";
import lovestory from "../assets/images/Portfolio/love-story-of-90s.jpg";
import Cuttputtli from "../assets/images/Portfolio/cuttputli.jpg";
import Taj from "../assets/images/Portfolio/the-taj-story.webp";
import merehusband from "../assets/images/Portfolio/mere-husband-ki-biwi.webp";
import Stream from "../assets/images/Portfolio/Bad-Newz-Movie-Review-and-Rating.jpg";

import Freelance from "../assets/images/Portfolio/11_11.webp";
import Inspector from "../assets/images/Portfolio/inspector_Avinash.jpg";
import Aura from "../assets/images/Portfolio/Crushed.jpg";

import Surtido from "../assets/images/Portfolio/RoyalEnfield.jpeg";
import xpulse from "../assets/images/Portfolio/xpulse.webp";
import swiggy from "../assets/images/Portfolio/swiggy.jpg";
import national from "../assets/images/Portfolio/National-Games.jpg";
import summit from "../assets/images/Portfolio/Global-SUMMIT.avif";

import ManagementApp from "../assets/images/Portfolio/MG-Hector.webp";
import Citroen from "../assets/images/Portfolio/Citroen.avif";

// Advantages
import Communicative from "../assets/images/Advantages/Communicative.png";
import Collaborative from "../assets/images/Advantages/Collaborative.png";
import Management from "../assets/images/Advantages/Management.png";
import Favorite from "../assets/images/Advantages/Favorite.png";

// Testimonials
import Anand from "../assets/images/Testimonials/Anand.jpg";
import raj from "../assets/images/Testimonials/raj.jpg";
import vashu from "../assets/images/Testimonials/vashu.jpeg";

// TeamMembers
import CEO from "../assets/images/TeamMembers/CEO.jpg";
import HRD from "../assets/images/TeamMembers/HRD.jpg";
import Finance from "../assets/images/TeamMembers/Finance.jpg";
import ProjectManager from "../assets/images/TeamMembers/Project-manager.jpg";
import Frontend1 from "../assets/images/TeamMembers/Frontend1.jpg";
import Frontend2 from "../assets/images/TeamMembers/Frontend2.jpg";
import Backend1 from "../assets/images/TeamMembers/Backend1.jpg";
import Backend2 from "../assets/images/TeamMembers/Backend2.jpg";
import Mobile1 from "../assets/images/TeamMembers/Mobile1.jpg";
import Mobile2 from "../assets/images/TeamMembers/Mobile2.jpg";
import UIUX1 from "../assets/images/TeamMembers/UIUX1.jpg";
import UIUX2 from "../assets/images/TeamMembers/UIUX2.jpg";

export const Services = [
  {
    title: "Film Production",
    imageUrl: Web,
    animation: "left",
  },
  {
    title: "Casting",
    imageUrl: Mobile,
    animation: "up",
  },
  {
    title: "Commercials",
    imageUrl: UIUX,
    animation: "right",
  },
];

export const Portfolios = [
  {
    id: "asd1293uasdads1",
    dis: "1",
    title: "Vicky Vidya Ka Wo Wala Video",
    imageUrl: Recruiting,
    type: "Films",
    responsibility: ["Casting", "Commercials"],
    // credit: "https://dribbble.com/shots/15164950-Recruiting-app",
  },
  {
    id: "asd1293uhjkhkjh21",
    dis: "1",
    title: "Bad Newz",
    imageUrl: Stream,
    type: "Films",
    responsibility: ["Casting", "Commercials"],
    // credit: "https://dribbble.com/shots/15276430-Stream",
  },
  {
    id: "asd1293uhjkhkjh22",
    title: "Cuttputlli",
    imageUrl: Cuttputtli,
    type: "Films",
    responsibility: ["Casting", "Commercials"],
    // credit: "https://dribbble.com/shots/15276430-Stream",
  },
  {
    id: "asd1293uhjkhkjh23",
    title: "Mere Husband Ki Biwi",
    imageUrl: merehusband,
    type: "Films",
    responsibility: ["Casting", "Commercials"],
    // credit: "https://dribbble.com/shots/15276430-Stream",
  },
  {
    id: "asd1293uhjkhkjh24",
    title: "The Taj Story",
    imageUrl: Taj,
    type: "Films",
    responsibility: ["Casting", "Commercials"],
    // credit: "https://dribbble.com/shots/15276430-Stream",
  },
  {
    id: "asd1293uhjkhkjh25",
    title: "Love Story of 90's",
    imageUrl: lovestory,
    type: "Films",
    responsibility: ["Casting", "Commercials"],
    // credit: "https://dribbble.com/shots/15276430-Stream",
  },
  {
    id: "asd1293uvbvcbbd3",
    dis: "1",
    title: "Gyaarah Gyaarah",
    imageUrl: Freelance,
    type: "Web Series",
    responsibility: ["Casting", "Commercials"],
    // credit: "https://dribbble.com/shots/15223131-Freelance-Mobile-App-Concept",
  },
  {
    id: "asd1293ufgdfgs4",
    dis: "1",
    title: "Crushed",
    imageUrl: Aura,
    type: "Web Series",
    responsibility: ["Film Production", "Commercials"],
    // credit: "https://dribbble.com/shots/15176338-Aura-Commercials-Main-Page",
  },
  {
    id: "asd1293ufgdfgs41",
    title: "Inspector Avinash",
    imageUrl: Inspector,
    type: "Web Series",
    responsibility: ["Film Production", "Commercials"],
    // credit: "https://dribbble.com/shots/15176338-Aura-Commercials-Main-Page",
  },
  {
    id: "asd1293ulskmnb5",
    dis: "1",
    title: "Royal Enfield",
    imageUrl: Surtido,
    type: "Commercials",
    responsibility: ["Film Production", "Commercials"],
    // credit: "https://dribbble.com/shots/15173118-Surtido-Rico",
  },
  {
    id: "asd1293ulkmnbj6",
    dis: "1",
    title: "MG Hector",
    imageUrl: ManagementApp,
    type: "Commercials",
    responsibility: ["Film Production", "Commercials"],
    // credit:
    // "https://dribbble.com/shots/15197890-Courses-Management-and-Promoting-Web-App",
  },
  {
    id: "asd1293ulkmnbj62",
    title: "Global Investor Summit 2023",
    imageUrl: summit,
    type: "Events",
    responsibility: ["Film Production", "Commercials"],
    // credit:
    // "https://dribbble.com/shots/15197890-Courses-Management-and-Promoting-Web-App",
  },
  {
    id: "asd1293ulkmnbj62",
    title: "38th National Games, Uttarakhand",
    imageUrl: national,
    type: "Events",
    responsibility: ["Film Production", "Commercials"],
    // credit:
    // "https://dribbble.com/shots/15197890-Courses-Management-and-Promoting-Web-App",
  },
  {
    id: "asd1293ulskmnb51",
    title: "X Pulse",
    imageUrl: xpulse,
    type: "Commercials",
    responsibility: ["Film Production", "Commercials"],
    // credit: "https://dribbble.com/shots/15173118-Surtido-Rico",
  },
  {
    id: "asd1293ulkmnbj61",
    title: "Swiggy",
    imageUrl: swiggy,
    type: "Commercials",
    responsibility: ["Film Production", "Commercials"],
    // credit:
    // "https://dribbble.com/shots/15197890-Courses-Management-and-Promoting-Web-App",
  },

  {
    id: "asd1293ulkmnbj62",
    title: "Citroen",
    imageUrl: Citroen,
    type: "Commercials",
    responsibility: ["Film Production", "Commercials"],
    // credit:
    // "https://dribbble.com/shots/15197890-Courses-Management-and-Promoting-Web-App",
  },
];

export const Advantages = [
  [
    {
      title: "Communicative",
      description:
        "We communicate our project ideas and progress to make it clear.",
      imageUrl: Communicative,
    },
    {
      title: "Management",
      description:
        "We manage our project properly to make our project done well.",
      imageUrl: Management,
    },
  ],
  [
    {
      title: "Collaborative​",
      description:
        "Our team are very collaborative to make our project done well.",
      imageUrl: Collaborative,
    },
    {
      title: "Favorite",
      description: "We've did so many project and all of our client love it.",
      imageUrl: Favorite,
    },
  ],
];
export const Testimonials = [
  {
    id: 1,
    name: "Anand Tiwari",
    company: "Director - Bad Newz",
    testimoni:
      "Thanks for LetMeCast & Prouduction Co. , you guys are the best! Keep up the great work!",
    imageUrl: Anand,
  },
  {
    id: 2,
    name: "Raj Shandalia",
    company: "Director - Vicky Veda ka Wo Wala Video",
    testimoni:
      "I just wanted to let you know that it’s been great working with LetMeCast & Prouduction Co.  .",
    imageUrl: raj,
  },
  {
    id: 3,
    name: "Vashu Bhagnani",
    company: "Producer - Cuttputtli",
    testimoni:
      "LetMeCast & Prouduction Co. is so great. Thank you so much for a job well done.",
    imageUrl: vashu,
  },
];

export const TeamMembers = [
  {
    name: "Rach David",
    position: "CEO",
    imageUrl: CEO,
  },
  {
    name: "Pauline Sydney",
    position: "HRD",
    imageUrl: HRD,
  },
  {
    name: "Granger Watterson",
    position: "Finance",
    imageUrl: Finance,
  },
  {
    name: "Tom Jimmy",
    position: "Project Manager",
    imageUrl: ProjectManager,
  },
  {
    name: "Jim Hendrix",
    position: "Front-end Developer",
    imageUrl: Frontend1,
  },
  {
    name: "Calvin Max",
    position: "Front-end Developer",
    imageUrl: Frontend2,
  },
  {
    name: "Hawkins Jim",
    position: "Back-end Developer",
    imageUrl: Backend1,
  },
  {
    name: "Don Bizaro",
    position: "Back-end Developer",
    imageUrl: Backend2,
  },
  {
    name: "Bill Markinson",
    position: "Mobile Developer",
    imageUrl: Mobile1,
  },
  {
    name: "Igor Kavarov",
    position: "Mobile Developer",
    imageUrl: Mobile2,
  },
  {
    name: "Freddie Curl",
    position: "Eventser",
    imageUrl: UIUX2,
  },
  {
    name: "Monica Lovegood",
    position: "Eventser",
    imageUrl: UIUX1,
  },
];
